import React from 'react';
import { useIntl } from 'react-intl';
import { Badge } from './Badge.js';
export function BetaBadge({ dataMetrics, dataTestId }) {
    const intl = useIntl();
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || 'badge-beta', addClassName: "twds-font-semibold", appearance: "teal" }, intl.formatMessage({
        defaultMessage: 'Beta',
        id: '1SPX7G',
        description: 'A feature not yet ready for general access'
    })));
}
//# sourceMappingURL=BetaBadge.js.map